<script>
import resources from './resources'

export default {
  name: 'schedulings-schedule',

  mixins: [resources]
}
</script>

<template lang="pug">
  li
    div(@click='showInfo()')
      .col-xs-12.col-sm-4.col-md-1
        small.grey
          | Data
          br
        | {{ schedule.date }}
      .col-xs-12.col-sm-4.col-md-1
        small.grey
          | Hora
          br
        |{{ schedule.time }}
      .col-xs-12.col-sm-4.col-md-3
        small.grey
          | Paciente
          br
        | {{ schedule.patient.name }}
      .col-xs-12.col-sm-4.col-md-3.name
        small.grey
          | Profissional
          br
        | {{ schedule.agenda.professional.name }}
      .col-xs-12.col-sm-4.col-md-2
        small.grey
          | Especialidade
          br
        template(v-if="schedule.speciality")
          | {{ schedule.speciality.name }}
      .col-xs-12.col-sm-4.col-sm-offset-4.col-md-2.col-md-offset-0.text-center
        small.grey
          | Situação
          br
        | {{ schedule._status }}
    .clearfix
    div.col-md-12(:class="{ 'profissional-info': !info }")
      .row.white-border-top(style="margin-top: 10px;")
        .hidden-xs.col-sm-4.col-md-2
          img.img-circle(:src='schedule.agenda.professional.avatar', style="border-radius: 50%; width: 144px;padding-left: 10px;")
        .col-xs-12.col-sm-8.col-md-4
          .info
            strong
              | {{ schedule.company_type }}
          .adress
            | {{ schedule.agenda.address.label }}
            br
            | {{ schedule.agenda.address.label2 }}
        .col-xs-12.col-sm-8.col-md-6(v-if="schedule.agenda.address.latitude && schedule.agenda.address.longitude")
          maps(:latitude='schedule.agenda.address.latitude', :longitude='schedule.agenda.address.longitude')

      .row.white-border-top.text-right(style="margin-top:10px;")
        button#hide.btn.cancel(@click.prevent="hideInfo()")
          span.icon 
          |  Fechar
</template>



// WEBPACK FOOTER //
// src/app/patient/agendas/schedulings/history/index/components/schedule/schedule.vue